// extracted by css-extract-rspack-plugin
export default {"content":"ta4JW","codeContainer":"kdpa4"};